import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnDestroy,
	OnInit
} from '@angular/core';
import { JobQuestionnarie } from '@models/models';

@Component({
	selector: 'questionnaire-submitted-statement',
	template: require('./questionnaire-submitted-statement.html'),
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionnaireSubmittedStatementComponent
	implements OnInit, OnDestroy {
	@Input() questionnaire: JobQuestionnarie;

	constructor() {}

	ngOnInit() {}

	ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/components/common/questionnaire-submitted-statement/questionnaire-submitted-statement.ts